import {KeyOfficeVisitReport} from "../../api/Model";
import React, {useCallback} from "react";
import {Card, CardContent, CardHeader, Grid, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {VisitChart} from "../../components/visit-chart/VisitChart";
import {CumulativeVisitChart} from "../../components/visit-chart/CumulativeVisitChart";
import {
    FigureVisitStatBlock,
    OverflowDaysStatBlock,
    VisitStatBlock,
    WeekVisitStatBlock
} from "../../components/visit-stat-block/VisitStatBlock";
import {MonthlyOfficeVisitReport} from "../../api/VisitWithStatStore";
import {GhostKeysStatBlock} from "./GhostKeysStatBlock";
import {NotReportedKeysStatBlock} from "./NotReportedKeysStatBlock";


export function VisitReportCard({report, onDeleteReport}: {
    report: MonthlyOfficeVisitReport,
    onDeleteReport?: (report: KeyOfficeVisitReport) => void,
}) {
    const date = new Date(report.uploaded);
    const onDelete = useCallback(() => onDeleteReport?.(report),
        [onDeleteReport, report]
    );

    return (
        <Card>
            <CardHeader
                title={report.month}
                action={onDeleteReport &&
                    <Tooltip title="Delete">
                        <IconButton
                            color="error"
                            onClick={onDelete}
                        >
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                }
            />
            <CardContent>
                <Stack direction="column" gap={2}>
                    <Stack direction="row" flexWrap="wrap" alignItems="baseline" gap={2}>
                        <VisitStatBlock>Desks: {report.deskCount}</VisitStatBlock>
                        <FigureVisitStatBlock stats={report.visitStats} field="avgVisits"/>
                        <FigureVisitStatBlock stats={report.visitStats} field="median"/>
                        <FigureVisitStatBlock stats={report.visitStats} field="percentile90"/>
                        <FigureVisitStatBlock stats={report.visitStats} field="maxVisits"/>
                        <WeekVisitStatBlock visits={report.visitStats.visits}/>
                        <OverflowDaysStatBlock stats={report.visitStats}/>
                        <GhostKeysStatBlock report={report}/>
                        <NotReportedKeysStatBlock validation={report.validation}/>
                    </Stack>
                    <Grid container spacing={2}>
                        <Grid size={6}>
                            <VisitChart visits={report.officeVisits} columnWidth={18} deskCount={report.deskCount}/>
                        </Grid>
                        <Grid size={6}>
                            <CumulativeVisitChart
                                cumulativeVisitDistribution={report.cumulativeVisitDistribution}
                                registeredKeyCount={report.validation.issuedKeys.length}
                                columnWidth={19}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </CardContent>
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography variant="body2">{report.from} – {report.to}</Typography>
                    |
                    <Typography variant="body2">Uploaded {date.toLocaleDateString("de")} {date.toLocaleTimeString("de")} by {report.uploadedByEmail}</Typography>
                </Stack>
            </CardContent>
        </Card>
    );
}
